export default __webpack_public_path__ + "static/media/dos_nu.8251826f.jpg";